import React from 'react';
import { BaseButton, getJobOptionLabel, useLang, useT } from '@repo/common';

/**
 * Visa 섹션 (하단 5번째). "Eligible visa types: E-7, F-2 …" + 스폰서십 여부.
 * 헤더의 E-7 Support 칩은 그대로 둔다.
 */
const PreferredVisaTypes = ({ job, optionMeta }) => {
  const t = useT();
  const { lang } = useLang();

  const visaLabels = (job?.visaTypeOptionItemIds || [])
    .map((id) => getJobOptionLabel(optionMeta, id, '', lang))
    .filter(Boolean);
  const sponsorship = Boolean(job?.visaSponsorship);

  const sponsorshipText = sponsorship
    ? t('E-7 sponsorship available', 'E-7 비자 스폰서십 가능')
    : t('Visa sponsorship not provided', '비자 스폰서십 미제공');

  return (
    <div>
      <div className='flex flex-col items-start py-[30px] w-full gap-2 tabletH:gap-4 text-text-primary'>
        <div className='typo-b18Strong self-stretch'>{t('Visa', '비자')}</div>

        <div className='flex flex-col gap-2 w-full'>
          {visaLabels.length === 0 ? (
            <p className='typo-b14 text-text-secondary'>
              {t('Not specified', '미지정')}
            </p>
          ) : (
            <div className='flex flex-wrap gap-2'>
              {visaLabels.map((visa) => (
                <BaseButton
                  key={visa}
                  size='s'
                  type='text_basic'
                  hideIcon
                  bgclass='h-7 bg-grayscale-gray02 px-3 py-1'
                  width='w-fit'
                  isStatic={true}
                >
                  {visa}
                </BaseButton>
              ))}
            </div>
          )}

          <p
            className={`typo-b14 ${sponsorship ? 'typo-b14Strong text-text-primary' : 'text-text-secondary'}`}
          >
            {sponsorshipText}
          </p>
        </div>
      </div>

      <div className='border-b border-grayscale-gray02' />
    </div>
  );
};

export default PreferredVisaTypes;
